module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "expertise"
  }, [_c('h1', [_vm._v("Technologies We Use")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('view-portfolio', {
    attrs: {
      "data": _vm.technologies,
      "itemsPerPage": _vm.itemsPerPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\tOnly having one tool to work with limits what you can achieve."), _c('br'), _vm._v("\n\t\t\tThat's why we believe a web-developer should have a whole toolbox of knowledge.\n\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0984b200!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/technologies/technologies.vue
// module id = 45
// module chunks = 1